import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import Loading from '../Common/Loading';

const MD_WeeklyPerformanceReport: React.FC = () => {
    const [searchParams] = useSearchParams();
    const [pdfUrl, setPdfUrl] = useState<string | null>(null);
    const [error, setError] = useState<string | null>(null);
    const [loading, setLoading] = useState(true);

    useEffect(() => {
        // Extract all query parameters passed to this component
        const stuSch = searchParams.get('StuSch') || '';
        const stuFam = searchParams.get('StuFam') || '';
        const studentId = searchParams.get('StudentId') || '';
        const firstName = searchParams.get('FirstName') || '';
        const country = searchParams.get('Country') || '';
        const subject = searchParams.get('Subject') || '';

        if (!stuSch || !stuFam || !studentId) {
            setError("Missing required student parameters to generate the report.");
            setLoading(false);
            return;
        }

        const API_BASE_URL = process.env.REACT_APP_DOCUMENT_LINK;
        const params = new URLSearchParams({
            StuSch: stuSch,
            StuFam: stuFam,
            StudentId: studentId,
            FirstName: firstName,
            Country: country,
            Subject: subject
        });

        const fetchPdf = async () => {
            try {
                // Fetch the PDF as a Blob
                const response = await fetch(`${API_BASE_URL}api/weekly_performance_report?${params.toString()}`);
                
                if (!response.ok) {
                    const json = await response.json();
                    throw new Error(json.error || 'Failed to generate PDF');
                }

                const blob = await response.blob();
                const blobUrl = URL.createObjectURL(blob);
                setPdfUrl(blobUrl);

            } catch (err: any) {
                setError(err.message);
                alert(err.message); // Legacy behavior: alert error and close
                // window.close(); 
            } finally {
                setLoading(false);
            }
        };

        fetchPdf();

        return () => {
            if (pdfUrl) {
                URL.revokeObjectURL(pdfUrl);
            }
        };
    }, [searchParams]);

    if (loading) {
        return <Loading />;
    }

    if (error) {
        return (
            <div style={{ padding: '20px', fontFamily: 'Arial', color: 'red', textAlign: 'center' }}>
                <h2>Error Generating Report</h2>
                <p>{error}</p>
                <button onClick={() => window.close()} style={{ padding: '10px 20px', cursor: 'pointer' }}>Close Window</button>
            </div>
        );
    }

    return (
        <div style={{ margin: 0, padding: 0, height: '100vh', width: '100vw', overflow: 'hidden' }}>
            {pdfUrl && (
                <iframe 
                    src={pdfUrl} 
                    title="Weekly Performance Report"
                    frameBorder="0" 
                    style={{ width: '100%', height: '100%', border: 'none' }}
                />
            )}
        </div>
    );
};

export default MD_WeeklyPerformanceReport;